<script setup lang="ts">

</script>

<template>
  <div class="auth-background"></div>
  <div class="md:h-screen flex flex-col items-center justify-center gap-6 p-6 _md:p-10">
    <slot />
  </div>
</template>

<style scoped>
.auth-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: transparent url("@/assets/images/backgrounds/auth-background-4.png") no-repeat fixed center center !important;
  background-size: cover !important;
}
</style>
